import type { TutorialSlide } from '../src/tutorial/types/tutorial.types';
import { TUTORIAL_SLIDE_VISUAL } from './tutorial.constants';

/**
 * First-run tutorial — design flow 2a "Combined flow": value + excitement only (no UI
 * walkthrough). Three screens: Hook → Duel (1v1 + pick types) → Climb (leaderboard +
 * live mascot customization). Headline placement + composition live in each scene component;
 * the variant maps: CORE_ACTION = Hook, REWARD = Duel, SOCIAL_FLEX = Climb.
 */
export const tutorialSlides: TutorialSlide[] = [
  {
    key: 'hook',
    headline: 'Predict every match.',
    subheadline: 'Call it. Beat your mates.',
    visualVariant: TUTORIAL_SLIDE_VISUAL.CORE_ACTION,
  },
  {
    key: 'duel',
    headline: 'Go head-to-head.',
    subheadline: 'Challenge a mate. One match, one winner.',
    visualVariant: TUTORIAL_SLIDE_VISUAL.REWARD,
  },
  {
    key: 'climb',
    headline: 'Look the part.',
    subheadline: 'Top the board.',
    visualVariant: TUTORIAL_SLIDE_VISUAL.SOCIAL_FLEX,
  },
];
